<template>
  <b-modal id="modalPricing" size="lg" :hide-footer="true" :lazy="true" @hide="resize" @show="init"
    title="Service Pricing">
    <p>Choose any service below to view your costs for that service. If you have any questions, please contact us at {{
      this.$store.state.site.PhoneNumber }}.
    </p>
    <h2>List</h2>
    <m-loader :show="displayPrice.length === 0" size="smBox" />
    <div class="list-group">
      <div v-for="datasource of datasources" v-if="checkPrice(datasource.code)" class="list-group-item">
        <div @click="getPriceByDataSource(datasource.code)" class="list-group-item-title"
          :class="{ 'list-group-item-active': currentPriceCode === datasource.code }">
          {{ datasource.title }}
        </div>


        <div v-if="currentPriceCode === datasource.code" class="table-box">
          <m-loader :show="!currentPrice.priceListDetail" size="smBox" />
          <div v-if="currentPrice.priceListDetail">
            <table class="table b-table table-striped table-hover">
              <tr>
                <td class="th-title">Price Attribute</td>
                <td class="th-title">Price per Record
                </td>
              </tr>
              <tr v-for="item of currentPrice.priceListDetail.slice(1, pageSize)">
                <td>{{ item.Price_Attribute }}</td>
                <td>{{ item.Range1_Price | numberFormat('$', 4) }}</td>
              </tr>
            </table>
            <p @click="viewMore" class="view-more" v-show="currentPrice.priceListDetail.length > pageSize">View More</p>
            <p class="min-box">
              Your cost per name is the sum of the base record plus any filters/attributes you use to build the list or
              choose to include in its output.<br />
              {{ currentPrice.minPrice | numberFormat('$', 4) }} minimum online order<br>
              <span v-for="listPrice of currentPrice.ListMultiplePrice" v-if="listPrice.MultipleId > 1">
                {{ listPrice.Desc }} use pricing is {{ listPrice.Multiple }}x single use pricing <br>
              </span>
            </p>
          </div>

        </div>
      </div>
    </div>

    <h2 class="item-title" v-if="hasDataService()">Data Services</h2>
    <m-loader :show="displayPrice.length === 0" size="smBox" />
    <div class="list-group">
      <div v-for="dataService of dataServices" v-if="checkPrice(dataService.code)" class="list-group-item">
        <div @click="getPriceByService(dataService.code)" class="list-group-item-title"
          :class="{ 'list-group-item-active': currentPriceCode === dataService.code }">
          {{ dataService.displayName }}</div>
        <div v-if="currentPriceCode === dataService.code" class="table-box">
          <m-loader :show="!currentPrice.MAUserPrice" size="smBox" />
          <div v-if="currentPrice.MAUserPrice">
            <table class="table b-table table-striped table-hover">
              <tr>
                <td class="th-title">Price Attribute</td>
                <td class="th-title" v-for="item of currentPrice.MAUserPrice.BoundNames">
                  {{ item }}
                </td>
              </tr>
              <tr v-for="item of currentPrice.MAUserPrice.ElementPrice.slice(0, pageSize)">
                <td>{{ item.PriceDesc }}</td>
                <td v-for="bound of item.MAPrice">{{ bound.Price1 | numberFormat('$', 4) }}</td>
              </tr>
            </table>
            <p @click="viewMore" class="view-more" v-show="currentPrice.MAUserPrice.ElementPrice.length > pageSize">View
              More</p>
            <p class="min-box">{{ currentPrice.MAMinOrderMount.Price1 | numberFormat('$', 4) }} minimum online order<br>
            </p>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      price: {},
      dataSourcePrice: {},
      currentPrice: {},
      currentPriceCode: '',
      pageSize: 10,
      dataServices: {
        '-1': { code: -1, displayName: 'Clean a List' },
        '-2': { code: -2, displayName: 'Enhance a List' },
        '-6': { code: -6, displayName: 'Enhance Bundle' },
        '-4': { code: -4, displayName: 'Email Append' },
        '-5': { code: -5, displayName: 'Email Verification' },
        '-3': { code: -3, displayName: 'Portrait Reports services' },
        '-7': { code: -7, displayName: 'Phone Append' },
        '-8': { code: -8, displayName: 'Phone Append Confirmation' },
        '-9': { code: -9, displayName: 'Reverse Phone Append' }
      }
    }
  },
  computed: {
    datasources() {
      return this.$store.state.config.datasource
    },
    displayPrice() {
      return this.$store.state.config.allowPriceListHelp
    }
  },
  created() {
  },
  methods: {
    hasDataService() {
      return this.displayPrice.find(val => {
        return val < 0
      })
    },
    checkPrice(code) {
      return this.displayPrice.find(val => {
        return val === code
      })
    },
    resize() {
      this.currentPrice = {}
      this.currentPriceCode = ''
      this.pageSize = 10
    },
    init() {
      this.$http.post('faq/Faqs-Pricing.aspx/GetPricingDisplayData', {}, {
        progressBar: false,
        errorType: 'silent'
      }).then(
        resp => {
          this.$store.commit('config/saveKey', ['allowPriceListHelp', resp.body.d.DataSource.DisplayData])
        })
    },
    viewMore() {
      this.pageSize += 20
    },
    getPriceByDataSource(code) {
      if (this.currentPriceCode === code) {
        this.currentPriceCode = ''
        return
      }
      this.resize()
      this.currentPriceCode = code
      this.$http.post('faq/Faqs-Pricing.aspx/GetPriceByDataSource', {
        listType: code
      }).then(
        resp => {
          this.currentPrice = resp.body.d.DataSource
        })
    },
    getPriceByService(code) {
      if (this.currentPriceCode === code) {
        this.currentPriceCode = ''
        return
      }
      this.resize()
      this.currentPriceCode = code

      this.$http.post('faq/Faqs-Pricing.aspx/GetMAPrice', {
        listType: [code]
      }).then(
        resp => {
          this.currentPrice = resp.body.d.DataSource[0]
        })
    }
  }
}
</script>

<style scoped lang="scss">
.table {
  margin-top: 16px;
}

.table-box {
  padding: 0 8px;
}

.list-group-item {
  padding: 0
}

.list-group-item-title:hover {
  color: #495057;
  background-color: #f8f9fa
}

.list-group-item-title {
  padding: 0.75rem 1.25rem;
  cursor: pointer;
}

.list-group-item-active {
  color: #fff;
  background-color: $color-primary;
}

.list-group-item-active:hover {
  color: #fff;
  background-color: $color-primary-deep;
}

.view-more {
  text-align: center;
  padding: 12px;
  background-color: $color-primary-light;
}

.view-more:hover {
  color: #495057;
  background-color: #f8f9fa;
  cursor: pointer;
}

.list-group {
  margin-bottom: 32px;
}

.th-title {
  font-weight: bold;
}

.min-box {
  margin-bottom: 16px;
  margin-left: 16px;
}
</style>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            


// WEBPACK FOOTER //
// src/components/landings/MModalPricing.vue